import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { CorrespondenceFile } from "@/types/CorrespondenceFile";
import displayErrorMessage from "../ErrorHandling";
import {
  convertCorrespondenceFileToBlob,
  getFileNameParts,
} from "../files/CorrespondenceFileConverter";
import { saveAs } from "file-saver-es";

export class ContactDocumentDownloader {
  private readonly _apiClient: AcquaintApiNextClient;

  constructor(apiClient: AcquaintApiNextClient) {
    this._apiClient = apiClient;
  }

  /** Downloads the file associated with the passed ContactDocument id */
  public async download(id: number): Promise<void> {
    const file = await this.getFile(id);

    if (!file) {
      return;
    }

    const blob = convertCorrespondenceFileToBlob(file);
    const fileNameParts = getFileNameParts(file.fileDownloadName);

    if (!fileNameParts) {
      return;
    }

    this.downloadBlob(blob, fileNameParts.nameWithExtension);
  }

  private async getFile(id: number) {
    try {
      return await this._apiClient.httpGet<CorrespondenceFile>(
        `ContactDocument/${id}`,
      );
    } catch (err) {
      displayErrorMessage(
        "The file could not be downloaded. It may have been deleted.",
      );
      return undefined;
    }
  }

  private downloadBlob(blob: Blob, fileName: string) {
    saveAs(blob, fileName);
  }
}
